import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface SupportAddonStatus {
  active: boolean
  billingCycle: string | null
  activatedAt: string | null
  expiresAt: string | null
  cancelAtPeriodEnd: boolean
}

// Support add-on status for the current tenant. Authenticated but not gated
// by the add-on itself, so the sidebar can decide whether to show the section.
export function useSupportAddon() {
  const { data, isLoading } = useQuery({
    queryKey: ['support-addon-status'],
    queryFn: async () => {
      const response = await api.get('/support/status')
      return response.data.data as SupportAddonStatus
    },
    staleTime: 5 * 60 * 1000,
  })

  return { status: data, active: data?.active ?? false, isLoading }
}
